import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { CreatePostTagDto, PostTagDto } from '../../tags-table/model/types';

const POST_TAGS = `/api/admin/tags`;

interface UpdateTagParams {
	uuid: string;
	request: Partial<CreatePostTagDto>;
}

export const useCreatePostTag = () => {
	const queryClient = useQueryClient();
	return useMutation<PostTagDto, any, CreatePostTagDto>(
		'post-tags',
		async request => {
			const { data: response } = await axios.post(`${POST_TAGS}/`, request);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('post-tags');
			},
		}
	);
};

export const useUpdatePostTag = () => {
	const queryClient = useQueryClient();
	return useMutation<PostTagDto, any, UpdateTagParams>(
		'post-tags',
		async ({ uuid, request }) => {
			const { data: response } = await axios.patch(
				`${POST_TAGS}/${uuid}`,
				request
			);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('post-tags');
			},
		}
	);
};

export const useDeletePostTag = () => {
	const queryClient = useQueryClient();
	return useMutation<PostTagDto, any, string>(
		'post-tags',
		async uuid => {
			const { data: response } = await axios.delete(`${POST_TAGS}${uuid}`);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('post-tags');
			},
		}
	);
};
